import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  deleteInventoryLocation,
  fetchInventoryLocation,
  fetchInventoryLocations,
  patchInventoryLocation,
  postInventoryLocation,
} from '@sophocles/api/inventoryLocations';

export const loadInventoryLocations = createAsyncThunk(
  'inventory/inventoryLocations/fetchMany',
  async (queryParams, { rejectWithValue }) => {
    try {
      const data = await fetchInventoryLocations(queryParams);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const loadInventoryLocation = createAsyncThunk(
  'inventory/inventoryLocations/fetchOne',
  async (locationId, { rejectWithValue }) => {
    try {
      const data = await fetchInventoryLocation(locationId);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const createInventoryLocation = createAsyncThunk(
  'inventory/inventoryLocations/create',
  async (payload, { rejectWithValue }) => {
    try {
      const data = await postInventoryLocation(payload);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const editInventoryLocation = createAsyncThunk(
  'inventory/inventoryLocations/patch',
  async ({ id, ...payload }, { rejectWithValue }) => {
    try {
      const data = await patchInventoryLocation(id, payload);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const removeInventoryLocation = createAsyncThunk(
  'inventory/inventoryLocations/delete',
  async (organizationId, { rejectWithValue }) => {
    try {
      await deleteInventoryLocation(organizationId);
      return organizationId;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);
